import { createContext } from 'ui/lib/react-utils'
import type { AssistantContextState } from '../types'

export const [AssistantProvider, useAssistantContext] = createContext<AssistantContextState>({
  name: 'Assistant'
})
